'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _tool = require("@entrylabs/tool");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2["default"])((0, _getPrototypeOf2["default"])(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
Entry.FieldTextInput = /*#__PURE__*/function (_Entry$Field) {
  function FieldTextInput(content, blockView, index) {
    var _this;
    (0, _classCallCheck2["default"])(this, FieldTextInput);
    _this = _callSuper(this, FieldTextInput, [content, blockView, index]);
    var _blockView$data = blockView.data,
      data = _blockView$data === void 0 ? {} : _blockView$data;
    var _data$type = data.type,
      type = _data$type === void 0 ? 'text' : _data$type;
    _this.type = type;
    _this.TEXT_Y_PADDING = 3;
    _this._blockView = blockView;
    _this.board = _this._blockView.getBoard();
    _this._block = blockView.block;
    _this.box = new Entry.BoxModel();
    _this.svgGroup = null;
    _this.optionWidget = null;
    _this.optionInput = null;
    _this.position = content.position;
    _this._contents = content;
    _this._isClearBG = content.clearBG || false;
    _this._index = index;
    _this._CONTENT_HEIGHT = _this.getContentHeight();
    _this._font_size = content.fontSize || 10;
    _this._neighborFields = null;
    _this.renderStart();
    return _this;
  }

  // 기본 모드의 keyEvent(tab) 용
  (0, _inherits2["default"])(FieldTextInput, _Entry$Field);
  return (0, _createClass2["default"])(FieldTextInput, [{
    key: "_focusNeighbor",
    value: function _focusNeighbor(direction) {
      var fields = this.getNeighborFields();
      var idx = fields.indexOf(this);
      if (direction === 'prev') {
        idx--;
      } else {
        idx++;
      }
      var field = fields[idx];

      //no field to focus
      if (!field) {
        return;
      }
      this.board.setSelectedBlock(field._blockView);
      this.destroyOption(undefined, true);
      field.renderOptions(fields);
    }
  }, {
    key: "renderStart",
    value: function renderStart() {
      var blockView = this._blockView;
      if (!this.svgGroup) {
        this.svgGroup = blockView.contentSvgGroup.elem('g');
      }
      if (!this.textElement) {
        this.textElement = this.svgGroup.elem('text', {
          x: 0,
          y: this.TEXT_Y_PADDING,
          fill: this._contents.color || 'black',
          'font-size': "".concat(this._font_size, "px"),
          'font-weight': 'bold',
          'font-family': EntryStatic.fontFamily || 'NanumGothic'
        });
      }
      this.svgGroup.attr({
        "class": 'entry-input-field'
      });
      this._setConvertedValue();
      var width = this.getTextWidth();
      var y = this.position && this.position.y ? this.position.y : 0;
      var CONTENT_HEIGHT = this._CONTENT_HEIGHT;
      y -= CONTENT_HEIGHT / 2;
      if (!this._header) {
        this._header = this.svgGroup.elem('rect', {
          width: width,
          x: 0,
          y: y,
          height: CONTENT_HEIGHT,
          rx: 0,
          ry: 3,
          fill: '#fff',
          'fill-opacity': 0
        });
      } else {
        this._header.setAttribute('width', width);
      }
      if (this._isClearBG) {
        $(this._header).css({
          stroke: 'none'
        });
      }
      this.svgGroup.appendChild(this.textElement);
      this._bindRenderOptions();
      this.box.set({
        x: 0,
        y: 0,
        width: width,
        height: CONTENT_HEIGHT
      });
    }
  }, {
    key: "renderOptions",
    value: function renderOptions(neighborFields) {
      var _this$_block = this._block,
        _block = _this$_block === void 0 ? {} : _this$_block;
      var _block$defaultType = _block.defaultType,
        defaultType = _block$defaultType === void 0 ? 'text' : _block$defaultType;
      if (neighborFields) {
        this._neighborFields = neighborFields;
      }
      this.optionGroup = Entry.Dom('div', {
        "class": 'entry-widget-parent',
        parent: $('body')
      });
      if (Entry.isMobile()) {
        if (defaultType === 'number') {
          this.optionWidget = this._getNumberOptionWidget();
        } else if (defaultType === 'angle') {
          this.optionWidget = this._getAngleOptionWidget();
        } else {
          this.optionInput = this._getInputFieldOption();
          this._attachDisposeEvent();
        }
      } else {
        if (defaultType === 'angle') {
          this.optionInput = this._getInputFieldOption();
          this.optionWidget = this._getAngleOptionWidget(this.optionInput[0]);
        } else {
          this.optionInput = this._getInputFieldOption();
          this._attachDisposeEvent();
        }
      }
      this._setTextValue();
      this.optionDomCreated();
    }
  }, {
    key: "_getNumberOptionWidget",
    value: function _getNumberOptionWidget() {
      var _this2 = this;
      return new _tool.Number({
        type: 'numberWidget',
        data: {
          eventTypes: ['mousedown', 'touchstart', 'wheel'],
          positionDom: this.svgGroup,
          onOutsideClick: function onOutsideClick() {
            _this2.destroyOption(undefined, true);
          }
        },
        container: this.optionGroup[0]
      }).on('click', function (eventName, value) {
        var prevValue = String(_this2.getValue());
        switch (eventName) {
          case 'buttonPressed':
            if (prevValue === '0' && _.includes(['0', '.'], value) === false) {
              prevValue = '';
            }
            _this2.applyValue(prevValue + value);
            break;
          case 'backButtonPressed':
            {
              var nextValue = prevValue.substring(0, prevValue.length - 1);
              _this2.applyValue(_.isEmpty(nextValue) ? 0 : nextValue);
              break;
            }
        }
      });
    }

    /**
     *
     * @param {Array} excludeDom outside 로 판단하지 않을 dom target list
     * @returns {EntryTool} Angle Widget
     * @private
     */
  }, {
    key: "_getAngleOptionWidget",
    value: function _getAngleOptionWidget() {
      var _this3 = this;
      for (var _len = arguments.length, excludeDom = new Array(_len), _key = 0; _key < _len; _key++) {
        excludeDom[_key] = arguments[_key];
      }
      return new _tool.Angle({
        type: 'angleWidget',
        data: {
          eventTypes: ['mousedown', 'touchstart', 'wheel'],
          angle: this.getValue(),
          outsideExcludeDom: excludeDom,
          positionDom: this.svgGroup,
          onOutsideClick: function onOutsideClick(angle) {
            _this3.applyValue(FieldTextInput._refineDegree(angle));
            _this3.destroyOption();
          }
        },
        container: this.optionGroup[0]
      }).on('click', function (eventName, value) {
        var nextValue = 0;
        switch (eventName) {
          case 'buttonPressed':
            {
              nextValue = _this3._getNextValue(value);
              break;
            }
          case 'backButtonPressed':
            {
              nextValue = _this3._getSubstringValue();
              break;
            }
        }
        _this3.applyValue(nextValue);
      }).on('change', function (value) {
        _this3.applyValue(String(value));
      });
    }
  }, {
    key: "_getInputFieldOption",
    value: function _getInputFieldOption() {
      var _this4 = this;
      var inputField = Entry.Dom('input', {
        "class": 'entry-widget-input-field',
        parent: $('body')
      });
      inputField.val(this.getValue());
      inputField.on('mousedown', function (e) {
        e.stopPropagation();
      });
      inputField.on('keyup', function (e) {
        _this4.applyValue(inputField[0].value, true);
        if (_.includes([13, 27], e.keyCode || e.which)) {
          _this4.destroyOption(undefined, true);
        }
      });
      inputField.on('keydown', function (e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 9) {
          e.preventDefault();
          _this4._focusNeighbor(e.shiftKey ? 'prev' : 'next');
        }
      });
      inputField.on('blur', function (e) {
        var isOptionGroupVisible = !!_this4.optionGroup.get(0).style.display;
        if (!isOptionGroupVisible) {
          _this4.destroyOption(undefined, true);
        }
      });
      var _this$board$scale = this.board.scale,
        scale = _this$board$scale === void 0 ? 1 : _this$board$scale;
      this._font_size = 10 * scale;
      var _this$getAbsolutePosF = this.getAbsolutePosFromDocument(),
        x = _this$getAbsolutePosF.x,
        y = _this$getAbsolutePosF.y;
      var height = (this._CONTENT_HEIGHT - 4) * scale;
      inputField.css({
        height: height,
        left: x + 1,
        top: y + (scale - 1) * 4 + 2 * scale - 1 * (scale / 2) - this.box.height / 2,
        width: this.box.width * scale,
        'font-size': "".concat(this._font_size, "px"),
        'background-color': EntryStatic.colorSet.block.lighten.CALC
      });
      inputField.focus && inputField.focus();
      inputField[0].setSelectionRange(0, inputField[0].value.length, 'backward');
      return inputField;
    }
  }, {
    key: "applyValue",
    value: function applyValue(value, isNotUpdate) {
      var result = value;
      if (this.optionWidget) {
        switch (this.optionWidget.type) {
          case 'angleWidget':
            this.optionWidget.data = {
              angle: FieldTextInput._refineDegree(value)
            };
            if (Entry.Utils.isNumber(value) && value.lastIndexOf('.') !== value.length - 1) {
              result = String(result % 360);
            }
            break;
        }
      }
      if (this.optionInput && !isNotUpdate) {
        this.optionInput.val(result);
      }
      this.setValue(result);
      this._setTextValue();
      this.resize();
    }
  }, {
    key: "resize",
    value: function resize() {
      var _this$board$scale2 = this.board.scale,
        scale = _this$board$scale2 === void 0 ? 1 : _this$board$scale2;
      var size = {
        width: this.getTextWidth()
      };
      var scaleSize = {
        width: this.getTextWidth() / scale
      };
      this._header.attr(scaleSize);
      this.box.set(scaleSize);
      this.optionInput && this.optionInput.css(size);
      this._blockView.dAlignContent();
    }
  }, {
    key: "destroyOption",
    value: function destroyOption(skipCommand, forceCommand) {
      this._setConvertedValue();
      if (this.optionWidget) {
        this.optionWidget.isShow && this.optionWidget.hide();
        this.optionWidget.remove();
        delete this.optionWidget;
      }
      if (this.optionInput) {
        this.optionInput.remove();
        delete this.optionInput;
      }
      _superPropGet(FieldTextInput, "destroyOption", this, 3)([skipCommand, forceCommand]);
    }
  }, {
    key: "getTextWidth",
    value: function getTextWidth() {
      return Math.max(this.getTextBBox().width, 7);
    }
  }, {
    key: "_setTextValue",
    value: function _setTextValue() {
      var value = this.getValue();
      if (this.textElement.textContent !== value) {
        this.textElement.textContent = value;
      }
    }
  }, {
    key: "_setConvertedValue",
    value: function _setConvertedValue() {
      var _this$_block2 = this._block,
        _block = _this$_block2 === void 0 ? {} : _this$_block2;
      var _block$defaultType2 = _block.defaultType,
        defaultType = _block$defaultType2 === void 0 ? 'text' : _block$defaultType2;
      var value = this._convert(this.getValue(), this.getValue());
      if (defaultType === 'angle') {
        value += '°';
      }
      if (this.textElement.textContent !== value) {
        this.textElement.textContent = value;
      }
    }
  }, {
    key: "getNeighborFields",
    value: function getNeighborFields() {
      if (!this._neighborFields) {
        var FIELD_TEXT_INPUT = Entry.FieldTextInput;
        this._neighborFields = this._block.getRootBlock().getThread().view.getFields().filter(function (f) {
          return f instanceof FIELD_TEXT_INPUT;
        });
      }
      return this._neighborFields;
    }

    /**
     * 기존 값의 뒤에 새 값을 추가한다. 내부에서 모든 숫자는 문자열이다.
     * 규칙은 아래와 같다.
     *
     * - 마이너스 입력은 현재 값이 0 인 경우만 가능
     * - . 은 값에서 유일하게 하나만 허용한다.
     * - 현재 값이 0 혹은 -0 인 경우 0은 입력할 수 없다. 다른 숫자는 입력할 수 있다.
     *
     * @param value 이번에 입력된 값
     * @return {string} 규칙에 맞추어 정제된 값
     * @private
     */
  }, {
    key: "_getNextValue",
    value: function _getNextValue(value) {
      var returnValue = String(this.getValue());
      returnValue = returnValue.replace('°', '');
      if (!FieldTextInput._isValidInputValue(value)) {
        return returnValue;
      }
      switch (value) {
        case '-':
          if (returnValue === '0') {
            return '-';
          }
          return returnValue;
        case '.':
          if (/\./.test(returnValue) || returnValue === '-') {
            return returnValue;
          }
          break;
        case '0':
          if (returnValue.startsWith('0') || returnValue.startsWith('-0')) {
            return returnValue;
          }
          break;
        default:
          if (returnValue === '0') {
            return value;
          }
          break;
      }
      returnValue += value;
      return returnValue;
    }

    /**
     * 현재 값 블록에서 마지막 숫자를 삭제한 값을 반환한다.
     * 0 인 경우는 0 을 반환, - 인 경우는 0 을 반환한다.
     * @returns {string} 마지막 위치가 삭제된 블록 값
     * @private
     */
  }, {
    key: "_getSubstringValue",
    value: function _getSubstringValue() {
      var returnValue = String(this.getValue());
      if (returnValue.length === 1) {
        return '0';
      } else {
        return returnValue.slice(0, returnValue.length - 1);
      }
    }
  }], [{
    key: "_refineDegree",
    value: function _refineDegree(value) {
      var reg = /&value/gm;
      if (reg.test(value)) {
        return value;
      }
      var numberOnlyValue = String(value).match(/[\d|\-|.|\+]+/g);
      var refinedDegree = numberOnlyValue && numberOnlyValue[0] || '0';
      if (refinedDegree > 360) {
        refinedDegree %= 360;
      } else if (refinedDegree < 0) {
        refinedDegree = refinedDegree % 360;
      }
      refinedDegree = String(refinedDegree);
      if (refinedDegree.lastIndexOf('.') === refinedDegree.length - 1) {
        return refinedDegree.slice(0, refinedDegree.length - 1);
      }
      return refinedDegree;
    }
  }, {
    key: "_isValidInputValue",
    value: function _isValidInputValue(value) {
      return Entry.Utils.isNumber(value) || value === '-' || value === '.';
    }
  }]);
}(Entry.Field);